import React from 'react';
import anchorme from "anchorme";
import { Richtext } from '../inputs/RichTextInput';
import { css } from 'office-ui-fabric-react';
import validator from 'validator';

type Props = {
    isMultiline?: boolean;
    isMultichoice?: boolean;
    withNavigation?: boolean;
    value?: string[] | string | Richtext | null;
    urlTextMaxLen?: number;
    hideTitle?: boolean;
    className?: string;
    showLinkAsIcon?: boolean;
};

export const getTextFormatterValue = (value?: string[] | string | { text?: string, Text?: string } | null, isMultichoice?: boolean): string | undefined =>
    !value
        ? undefined
        : isMultichoice && Array.isArray(value)
            ? value.join(', ')
            : Array.isArray(value)
                ? value.join()
                : typeof value === "object"
                    ? value?.text ?? value?.Text
                    : value;

export const TextFormatter = (props: Props) => {
    const value = getTextFormatterValue(props.value, props.isMultichoice);
    const className = css('text-formatter', props.className, props.isMultiline ? 'multiline' : undefined);

    const html = value && props.withNavigation && anchorme({
        input: value.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;"),
        options: {
            truncate: props.urlTextMaxLen,
            exclude: (arg) => anchorme.validate.ip(arg) || isPseudoIp(arg),
            attributes: {
                target: "_blank",
                class: "text-link",
                onclick: "event.stopPropagation()"      // Stop closing inline editor
            },
            specialTransform: props.showLinkAsIcon ? [{
                test: /.*/,
                transform: (input: string, props) => {
                    if (anchorme.validate.email(input)) {
                        return `<a href='mailto:${input}' target='_blank' class='text-link' onclick="event.stopPropagation()">${input}</a>`;
                    }
                    if ((validator.isURL(input) || anchorme.validate.file(input)) && !anchorme.validate.ip(input)) {
                        input = props.protocol ? input : `https://${input}`;
                        return `<a href='${input}' target='_blank' class='icon-link' onclick="event.stopPropagation()"></a>`;
                    }
                    return input;
                }
            }] : undefined
        }
    });

    return (
        html
            ? <span
                className={className}
                title={props.hideTitle ? undefined : value}
                dangerouslySetInnerHTML={{ __html: html }}
            />
            : <span className={className} title={props.hideTitle ? undefined : value}>{value}</span>
    );
}

// checks if arg contains digits and dots only one after the other (i.e. d.d.d.d.d)
const isPseudoIp = (arg: string): boolean => /^\d+(\.\d+)*$/gm.test(arg);